import React from 'react'
import Slide1 from '../../../assets/Predator_Wallpaper_01_3840x2400.jpg';
import Slide2 from '../../../assets/Predator_Wallpaper_02_3840x2400.jpg';
import Slide3 from '../../../assets/Predator_Wallpaper_03_3840x2400.jpg';
import Slide4 from '../../../assets/Predator_Wallpaper_04_3840x2400.jpg';
import Slide5 from '../../../assets/Predator_Wallpaper_05_3840x2400.jpg';
import '../Lobby.css'
import { Link } from 'react-router-dom';
import GBall from '../../../../public/images/g-ball.png'
import Sk from "../../../../public/images/sp.png"
import LC from "../../../../public/images/lc.png"
import Sb from "../../../../public/images/sb.png"
import GameCard from '../../../components/Gmage-Card/GameCard';
import Zoom1 from '../../../../public/images/ninewCricket.png'
import Zoom2 from '../../../../public/images/z1.jpg'
import Zoom3 from '../../../../public/images/z2.jpg'
import Zoom4 from '../../../../public/images/sakibal.jpg'
import Zoom5 from '../../../../public/images/virat.png'
import Accordian from '../../../components/Gmage-Card/Accordian';
import GameFooter from '../../../components/Gmage-Card/GameFooter';
import { Carousel } from '../../../components/ReusableComponent/Carousel';
import Promotions from '../../../components/ReusableComponent/WelcomeAd';
import Subnavbar from '../../../components/Subnavbar';



const slides = [
    {
        id: 4,
        image: Slide4,
        title: 'Join GUGOBET WhatsApp Channel',
    },
    {
        id: 1,
        image: Slide1,
        title: 'Join GUGOBET WhatsApp Channel',
    },
    {
        id: 2,
        image: Slide2,
        title: 'Join GUGOBET WhatsApp Channel',
    },
    {
        id: 3,
        image: Slide3,
        title: 'Join GUGOBET WhatsApp Channel',
    },

    {
        id: 5,
        image: Slide5,
        title: 'Join GUGOBET WhatsApp Channel',
    },
    // Add more slides as needed
]
const Sports = () => {

    
    return (<>
  
        <div>
            <div class="main-navigation__item"><div class="main-navigation__icon-wrapper"><div class="main-navigation__icon main-navigation__icon--cricket"><div class="dot-wrapper"><div class="dot"></div></div></div></div> <h2 class="main-navigation__text fz-12 fw-600 c-fff ta-center whsp-nowrap m-initial">

            </h2></div>
        </div>
        <div className="main-cotegory-title mt-3">
            <div className=" flex items-center">
                <div className="crk-icon"></div>
                <div className="Sports text-white font-semibold text-[17px]">Sports

                </div>
            </div>
            <div className="title-divaider"></div>
            <div className=" flex items-center">
                <div className="sec-icon mt-2"></div>
                <div className="Sports text-white font-semibold text-[17px]">Provider</div>
            </div>
        </div>
        {/* end title */}
        <div className="vtn-menus mt-4">
            <ul className='flex gap-2'>
                <li className='px-3 py-2 bg-[#303030] rounded-md'><Link to="#" className='flex items-center text-white text-[14px]  font-semibold'><img src={GBall} alt="gball" className='w-[20px] h-[20px] mr-2' /> 9wicket</Link></li>
                <li className='px-3 py-2 bg-[#303030] rounded-md'><Link to="#" className='flex items-center text-white text-[14px]  font-semibold'><img src={Sk} alt="gball" className='w-[20px] h-[20px] mr-2' /> IM Exchange</Link></li>
                <li className='px-3 py-2 bg-[#303030] rounded-md'><Link to="#" className='flex items-center text-white text-[14px]  font-semibold'><img src={LC} alt="gball" className='w-[20px] h-[20px] mr-2' /> LuckySports</Link></li>
                <li className='px-3 py-2 bg-[#303030] rounded-md'><Link to="#" className='flex items-center text-white text-[14px]  font-semibold'><img src={Sb} alt="gball" className='w-[20px] h-[20px] mr-2' />SABA</Link></li>

            </ul>
        </div>

        <div>
       <div>
       <h3 className='text-[#818B9A] font-semibold text-[20px]'>Cricket</h3>
       <div className="all-games mt-5">
            
            <div className='flex gap-5'>
                <GameCard poster={Zoom1} headening="Exchange Cricket" />
                <GameCard poster={Zoom2} headening="Premium Cricket" />
                <GameCard poster={Zoom3} headening="Cyber Cricket" />
                <GameCard poster={Zoom4} headening="Sportsbook Cricket" />
                <GameCard poster={Zoom5} headening="Virtual Cricket" />
            </div>
        </div>
       </div>
        <div className="all-games mt-10">
            <h3 className='text-[#818B9A] font-semibold text-[20px]'>Football</h3>
            <div className='flex gap-5'>
                <GameCard poster={Zoom1} headening="Exchange Cricket" />
                <GameCard poster={Zoom2} headening="Premium Cricket" />
                <GameCard poster={Zoom3} headening="Cyber Cricket" />
                
            </div>
        </div>
        <div className="all-games mt-10">
            <h3 className='text-[#818B9A] font-semibold text-[20px]'>Tennis</h3>
            <div className='flex gap-5'>
                <GameCard poster={Zoom1} headening="Exchange Cricket" />
                <GameCard poster={Zoom2} headening="Premium Cricket" />
                <GameCard poster={Zoom3} headening="Cyber Cricket" />
                
            </div>
        </div>
        <div className="all-games mt-10">
            <h3 className='text-[#818B9A] font-semibold text-[20px]'>Basketball</h3>
            <div className='flex gap-5'>
                <GameCard poster={Zoom1} headening="Exchange Cricket" />
                
            </div>
        </div>
        </div>
        {/* accourdian */}
     <Accordian/>
     <GameFooter/>


    </>
    )
}

export default Sports